module.exports = __webpack_public_path__ + "img/金凤.f5e2ddcc.jpg";